import { render } from "./EndEvent.vue?vue&type=template&id=707363b4"
import script from "./EndEvent.vue?vue&type=script&lang=js"
export * from "./EndEvent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__